import React from "react";
import styled, { useTheme } from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons";

const ArrowIcon = ({
  style,
  onClick,
}: {
  style?: React.CSSProperties;
  onClick?: () => void;
}): JSX.Element => {
  const theme = useTheme();

  const IconStyles = {
    width: "20px",
    height: "20px",
  };

  return (
    <Button style={style} onClick={onClick ? onClick : undefined}>
      <FontAwesomeIcon
        icon={faChevronUp}
        style={{
          ...IconStyles,
          color: theme.colours.background,
        }}
      />
    </Button>
  );
};
const Button = styled.button`
  border: none;
  outline: none;
  width: 40px;
  height: 40px;
  border-radius: ${(props) => props.theme.borderRadius.circle};
  background: ${(props) => props.theme.colours.midBlue};
  transition: all 0.2s ease-in;
  &:hover {
    cursor: pointer;
    background: ${(props) => props.theme.colours.orange};
  }
`;

export default ArrowIcon;
